import React from "react";

const Fourth = ({ msg, color }) => {
  return (
    <>
      <ul class="list-disc pl-4 md:p-10 space-y-3 text-gray-500 mt-2">
                    <li>Kuwa na ofisi za akademia</li>
                    <li>
                      Kuwa na kiwanja/ viwanja vya michezo, chumba cha mazoezi
                      nk
                    </li>
                    <li>Kuwa na vifaa vya wachezaji na vifaa vya michezo</li>
                    <li>
                      Kuwa na Walimu au kuwepo uwezekano wa kupata walimu wa
                      michezo na wataalam wengine wa michezo
                    </li>
                    <li>
                      kuwa na huduma ya chakula na malazi kulingana na mahitaji
                      ya watu wote
                    </li>
                    <li>
                      Kuwa na madarasa kwa ajili ya kufundishia vipindi vya
                      masomo, semina n.k
                    </li>
                  </ul>
    </>
  );
};

export default Fourth;
